import React, { useEffect, useState, useContext } from 'react'
import PracticeLocationAvailabilityService from '../../../../services/api/practice-location-availablity.service';
import List from '../../../templates/components/List'
import Select from "react-select"
import toast from 'react-hot-toast';
import ModalBox from '../../../templates/components/ModalBox';
import PracticeLocationSelector from '../../../templates/components/PracticeLocationSelector'
import { store } from "../../../../context/StateProvider";
import moment from "moment";
import DimLoader from '../../../templates/components/DimLoader';
import APIResponse from '../../../templates/components/APIResponse';

const PracticeLocationAvailablityList = (props) => {
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const dispatch = globalStateAndDispatch.dispatch
    const [isLoader, setIsLoader] = useState(false)
    const [sortBy, setSortBy] = useState('')

    const [locationId, setLocationId] = useState(state.practiceLocationId || null);
    const [locationLookupList, setLocationLookupList] = useState([])
    const [deleteModal, setDeleteModal] = useState(0)
    const [selectedRow, setSelectedRow] = useState()
    const [apiResponse, setApiResponse] = useState()

    const dowList = [
        {
            label: 'Sun',
            value: 1
        },
        {
            label: 'Mon',
            value: 2
        },
        {
            label: 'Tue',
            value: 3
        },
        {
            label: 'Wed',
            value: 4
        },
        {
            label: 'Thu',
            value: 5
        },
        {
            label: 'Fri',
            value: 6
        },
        {
            label: 'Sat',
            value: 7
        },
    ]

    const onSort = (e) => {
        setSortBy(e.target.value)
    }

    const onSuccess = (message) => {
        setLocationLookupList()
        getLocationAvailablity();
        dispatch({
            type: "setLocationAvailability",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const getLocationAvailablity = () => {
        setIsLoader(true);
        PracticeLocationAvailabilityService.practiceLocationAvailablity({ PracticeLocationId: locationId })
            .then((response) => {
                if (response && response.selectResponse) {
                    const sortedResponse = [...response.selectResponse].sort((a, b) => (a.dow > b.dow) ? 1 : ((b.dow > a.dow) ? -1 : 0));
                    sortedResponse.forEach(obj => {
                        obj.startTime = formatAsLocalTime(obj.startTime)
                        obj.endTime = formatAsLocalTime(obj.endTime)
                        obj.isChanged = false
                    });
                    setLocationLookupList(sortedResponse);
                } else {
                    setLocationLookupList([]);
                }
            })
            .catch(error => {
                console.error('Error fetching location availability:', error);
                setLocationLookupList([]);
            })
            .finally(() => {
                setIsLoader(false);
            })
    }

    const formatAsLocalTime = (time) => {
        let timeParts = time.split(":")
        let localDate = moment('1900-01-01T' + timeParts[0] + ":" + timeParts[1] + ":00.000").format("HH:mm")
        return localDate
    }


    const addHandler = (e) => {
        e.preventDefault();
        let newStateObject = [...locationLookupList];
        newStateObject.push({ dow: 0, startTime: '', endTime: '', isChanged: true, practiceLocationId: locationId });
        setLocationLookupList(newStateObject);
    }

    const inputChange = (e, i) => {
        let newStateObject = [...locationLookupList];
        newStateObject[i][e.target.name] = e.target.value;
        newStateObject[i]["isChanged"] = true
        return setLocationLookupList(newStateObject);
    }

    const saveRow = (src) => {
        const getMinutes = s => {
            const p = s.split(':').map(Number);
            return p[0] * 60 + p[1];
        };

        if (isOverlapping(locationLookupList)) {
            toast.error('Time slots are overlapping. Please adjust the schedule.')
        } else if (src.startTime && src.endTime && getMinutes(src.startTime) >= getMinutes(src.endTime)) {
            toast.error('Start time must be less than end time.')
        } else if (src.dow && src.startTime && src.endTime && locationId) {
            console.log('VALID')
            setIsLoader(true);
            const reqObj = {
                dow: src.dow,
                startTime: formatAsLocalTime(src.startTime),
                endTime: formatAsLocalTime(src.endTime),
                practiceLocationId: locationId
            }
            const resObj = src.practiceLocationAvailabilityId ? PracticeLocationAvailabilityService.updateAvailability(reqObj, src.practiceLocationAvailabilityId) : PracticeLocationAvailabilityService.createAvailability(reqObj)
            resObj.then(response => {
                setApiResponse(response)
            }).catch(error => {
                setApiResponse(error)
            })
                .finally(() => {
                    setIsLoader(false)
                });
        } else {
            toast.error('Please select a day and valid start & end times.')
        }
    }

    const deleteAvailability = () => {
        setIsLoader(true)
        PracticeLocationAvailabilityService.deleteAvailability(selectedRow.practiceLocationAvailabilityId)
            .then(response => {
                setApiResponse(response)
            }).catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setSelectedRow()
                setIsLoader(false)
            });
    }

    const overlapping = (a, b) => {
        const getMinutes = s => {
            const p = s.split(':').map(Number);
            return p[0] * 60 + p[1];
        };
        return getMinutes(a.endTime) > getMinutes(b.startTime) && getMinutes(b.endTime) > getMinutes(a.startTime);
    };

    const isOverlapping = (arr) => {
        let i, j;
        for (i = 0; i < arr.length - 1; i++) {
            for (j = i + 1; j < arr.length; j++) {
                if ((arr[i].practiceLocationId == arr[j].practiceLocationId) && (arr[j].practiceLocationAvailabilityId != arr[i].practiceLocationAvailabilityId) && (arr[i].dow == arr[j].dow) && overlapping(arr[i], arr[j])) {
                    return true;
                }
            };
        };
        return false;
    };

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }

    useEffect(() => {
        if (state?.practiceLocationId) {
            setLocationId(state.practiceLocationId)
        }
    }, [state?.practiceLocationId])

    useEffect(() => {
        // Clear the list when locationId changes
        setLocationLookupList([]);
        if (locationId) {
            getLocationAvailablity();
        }
    }, [locationId])

    return (
        <>
        {isLoader && <DimLoader />}
        <div className='w-100'>
            <div className='col-12'>
                <div className='field mb-3 input-group'>
                    <PracticeLocationSelector dontResetState={true} onSelected={onLocationChanged}/>
                    <button className='btn btn-primary' title="Add Location" onClick={addHandler}>Add</button>
                </div>
            </div>
            <List
                className='col-12'
                sortFunc={onSort}
                // pageSize={3}
                noPaginate={true}
                isLoading={isLoader}
            >
                {!isLoader && locationLookupList && locationLookupList.map((src, i) => {
                    return (
                        <div className="card mb-3 p-3 availability-bar" key={i}>
                            <div className="row d-flex justify-content-between align-items-center g-3">
                                <div className="col-md-3 col-12">
                                    <div className="content">
                                        <div className="ui sub">
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={dowList.find(obj => obj.value === src.dow)}
                                                options={dowList}
                                                onChange={e => { 
                                                    if(e){
                                                        inputChange({ target: { value: e.value , name: 'dow' } }, i) 
                                                    }else{
                                                        inputChange({ target: { value: 0 , name: 'dow' } }, i)
                                                    }
                                                    
                                                }}
                                                isClearable={true}
                                                getOptionLabel={(option) => { return (option.label) }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-12">
                                    <div className="content">
                                        <div className="ui">
                                            <input
                                                type='time'
                                                className="form-control"
                                                name="startTime"
                                                value={src.startTime}
                                                onInput={(e) => { e.preventDefault(); inputChange(e, i) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="item col-md-3 col-12">
                                    <div className="content">
                                        <div className="ui">
                                            <input
                                                type='time'
                                                className="form-control"
                                                name="endTime"
                                                value={src.endTime}
                                                onInput={(e) => { e.preventDefault(); inputChange(e, i) }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-12">
                                    <div className="content">
                                        <div className="btn-group m-w-100">
                                            <button className='btn btn-primary' title="Save Availability" onClick={e => { saveRow(src) }} disabled={!src.isChanged}>Save</button>
                                            <button className='btn btn-secondary' title="Delete Availability" onClick={e => { e.preventDefault(); 
                                                if (src.practiceLocationAvailabilityId) {
                                                    setSelectedRow(src); return setDeleteModal(true)
                                                } else {
                                                    const newArr = [...locationLookupList]; // create a copy of the array
                                                    newArr.splice(i, 1);
                                                    setLocationLookupList(newArr);
                                                }
                                                 }}>Delete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
                )}
            </List>
            </div>
            <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Block">
                <div className='row d-flex align-items-center justify-content-between'>
                    <div className='col'>
                        Are you sure you want to delete?
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-secondary' onClick={e => { e.preventDefault(); return setDeleteModal(false) }}>No</button>
                        <button className='btn btn-primary ms-3' onClick={e => { e.preventDefault(); setDeleteModal(false); deleteAvailability(); }}>Yes</button>
                    </div>
                </div>
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />

        </>
    )
}

export default PracticeLocationAvailablityList